import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseRichService } from './base-rich.service';



@Injectable()
export class UserService extends BaseRichService {

  setAlias(username: string, alias: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {

      username: username,
      alias: alias
    };

    return this.http.post(this.url + 'api/user/set_alias', body, { headers: headers });
  }

  getAvailableSims() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      query: [['holder', '=', this.username], 'and', ['status', '=', 'E']],
      fields: ['id', 'imsi', 'msisdn', 'vendor', 'is_fd'],
      raw: true
    };

    return this.http.post(this.url + 'api/tdlte_sim/read', body, { headers: headers });
  }

  dynamicIPAssign(username: string, range: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username,
      range
    };

    return this.http.post(this.url + 'api/user/dynamic_ip_assign', body, { headers: headers });
  }


  setPassword(service_type: string, username: string, password: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      service_type,
      username,
      password
    };

    return this.http.post(this.url + 'api/user/set_password', body, { headers: headers });
  }

  sendPassword(username: string, lang: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {

      username: username,
      lang: lang
    };

    return this.http.post(this.url + 'api/user/send_password', body, { headers: headers });
  }

  sendAccountPassword(username: string, lang: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username,
      lang: lang,
      checkMobile: false
    };

    return this.http.post(this.url + 'api/account/sendAccountPassword', body, { headers: headers });
  }

  setChangePassword() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {};

    return this.http.post(this.url + 'api/account/set_change_password', body, { headers: headers });
  }

  readTypeahead(term: string, searchMode: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    if (term === '' || term.length < 3) {
      return of([]);
    }

    let fields;
    if (searchMode === 'user') {
      fields = ['name', 'family', 'account_id', 'username'];
    } else {
      fields = ['name', 'family', 'username'];
    }

    return this.http.post(`${this.url}api/${searchMode}/read`, {
      query: [
        ['username', 'contains', `%${term}%`],
        'or',
        ['legacy_username', 'contains', `%${term}%`],
        'or',
        ['name', 'contains', `%${term}%`],
        'or',
        ['family', 'contains', `%${term}%`],
        'or',
        ['fullname', 'contains', `%${term}%`]
      ],
      fields,
      orderBy: `IF(username LIKE '${term}%', 0, 1), IF(legacy_username LIKE '${term}%', 0, 1), IF(name LIKE '${term}%', 0, 1), IF(family LIKE '${term}%', 0, 1)`,
      desc: false,
      limit: 10,
      raw: true
    }, { headers: headers }).pipe(map((response: any) => response));
  }

  getMe() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {};

    return this.http.post(this.url + 'api/user/getMe', body, { headers: headers });
  }

  getAlarms(userid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      subentity: 'general.alarm',
      entity: 'USER',
      ref: userid
    };
    return this.http.post(this.url + 'api/issue/read', body, { headers: headers });
  }

  dismissAlarm(alarm, comment) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      id: alarm.id,
      data: { comment },
      action: alarm.status === 'OPEN' ? 'FINISH' : 'CLOSE'
    };
    return this.http.post(this.url + 'api/issue/transit', body, { headers: headers });
  }

  confirmCaptcha(response) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      response
    };
    return this.http.post(this.url + 'api/auth/captcha', body, { headers: headers });
  }

  createInvoiceAndPay(account, username, service_type, vendor, service_price, item_price,
    activation_fee, installation_cost, wire_cost, transportation_cost, shipping_cost, request_installer, install_location, dsl_center_id?) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    const body = {
      account, username, service_type, vendor, service_price, item_price,
      activation_fee, installation_cost, wire_cost, transportation_cost, shipping_cost, request_installer, install_location, dsl_center_id
    };
    return this.http.post(this.url + 'api/invoice/create_and_pay', body, { headers: headers });
  }

  getShipmentCost(location, item_price) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      location, item_price
    };
    return this.http.post(this.url + 'api/item_price/get_shipment_cost', body, { headers: headers });
  }

  getAccount(username) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      query: ['username', '=', username],
      fields: ['username', 'person_type', 'fullname', 'postal_code', 'balance', 'province', 'city', 'address', 'unit', 'agent_id'],
      raw: true
    };
    return this.http.post(this.url + 'api/account/read', body, { headers: headers });
  }

  getLegals(username) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      query: ['agent_id', '=', username],
      fields: ['username', 'fullname'],
      raw: true
    };
    return this.http.post(this.url + 'api/account/read', body, { headers: headers });
  }

  getExtras(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username,
    };
    return this.http.post(this.url + 'api/service/getExtras', body, { headers: headers });
  }

  getItems(username: string, ip: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username,
      ip: ip
    };
    return this.http.post(this.url + 'api/service/getItems', body, { headers: headers });
  }

  getItemsByServiceType(service_type) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      service_type
    };
    return this.http.post(this.url + 'api/service/getItemsByServiceType', body, { headers: headers });
  }

  getFlow(type) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    return this.http.post(this.url + 'api/issue/getFlow', { type }, { headers: headers });
  }

}
